import { render, staticRenderFns } from "./ONavBar.vue?vue&type=template&id=45061522&"
import script from "./ONavBar.vue?vue&type=script&lang=js&"
export * from "./ONavBar.vue?vue&type=script&lang=js&"
import style0 from "./ONavBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports